/**
 * Created by koqiui on 2017-04-12.
 */
import api from './index';

let exports = {};

exports.getServcOrderDetailedInfo = function (data, callback) {// 查询服务订单
    api.post('/servc/order/detailed/info/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 获取服务显示分类（tree）
exports.saveServcOrder = function (postData, callback) {// 保存订单信息
    api.post('/servc/order/save/do')
    .data(postData)
    .done(callback)
    .go();
};

exports.getServOrderList = function (postData, callback) {// 服务订单列表
    api.post('/servc/order/list/get')
    .data(postData)
    .done(callback)
    .go();
};

exports.getServcOrderInfo = function (postData, callback) {// 服务订单明细
    api.post('/servc/order/info/get')
    .data(postData)
    .done(callback)
    .go();
};

// 通过订单id，订单项id获取订单及订单项信息
exports.getServcOrderByIdAndItemId = function (data, callback) {// 通过订单id，与订单项id获取订单和订单项的信息（售后下单用）
    api.post('/servc/order/get/by/id/and/itemId')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.designateServcShop = function (data, callback) {// 指派门店
    api.post('/servc/order/servc/shop/designate/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.saveServcOrderAfterSale = function (data, callback) {// 保存售后服务订单信息
    api.post('/servc/order/after/sale/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getServOrderRecordList = function (data, callback) {// 服务订单记录
    api.post('/servc/order/record/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.modifyPrice = function (data, callback) {// 服务订单记录
    api.post('/servc/order/totalDiscount/modify/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.doCancelServcOrder = function (data, callback) {// 服务订单记录
    api.post('/servc/order/cancel/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};


export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/servcOrder.js
// module id = 50
// module chunks = 1